import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const EnrollPhone = observer(class EnrollPhone extends React.Component {
  constructor() {
    super();
    this.handlePC = this.handlePC.bind(this);
  }

  handlePC(e) {
    const callback = (e) => {this.props.setStep(e, 4)}

    this.props.store.SmarterIDStore.createSIDEnrollment(callback);
  }

  render() {
    const { translation } = this.props;

    return(
      <div className={`panel panel--brief ${this.props.isActive}`}>
        <h1 className="panel__title">{translation.heading}</h1>

        <p>{translation.body}</p>

        <ul>
          {translation.phone_requirements.map(
            (requirement, i) =>
            <li key={i}>{requirement}</li>
          )}
        </ul>

        <div className="actions panel__actions">
          <button className="btn actions__btn" onClick={(e) => {this.props.setStep(e, 3)}}>
            {translation.yes}
          </button>

          <button className="btn btn--outline actions__btn" onClick={(e) => {this.handlePC(e)}}>
            {translation.no}
          </button>
        </div>
      </div>
    );
  }
})

export default translate('EnrollPhone')(EnrollPhone);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollPhone.js